<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Customer"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedCustomers"
      :columns="columns"
      :total-rows="totalCustomers"
      :get-edit-url="getEditUrl"
    >
      <template #actions="{ row }">
        <q-td class="q-pa-none text-center">
          <q-btn
            size="sm"
            color="primary"
            label="Edit"
            @click="$router.push(getEditUrl(row))"
            class="q-mr-sm"
          />
          <q-btn
            size="sm"
            :color="row.is_active ? 'negative' : 'positive'"
            :label="row.is_active ? 'Deactivate' : 'Reactivate'"
            @click="toggleActive(row)"
          />
        </q-td>
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'CustomerTable',
  components: {
    BaseTable
  },
  data() {
    return {
      customers: [],
      totalCustomers: 0,
      columns: [
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'city', align: 'left', label: 'City', field: 'city', sortable: true },
        { name: 'state', align: 'left', label: 'State', field: 'state', sortable: true },
        { name: 'office_phone', align: 'left', label: 'Office Phone', field: 'office_phone', sortable: true },
        { name: 'email', align: 'left', label: 'Email', field: 'email', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedCustomers() {
      return this.customers.map(customer => ({
        ...customer,
        add_date: new Date(customer.add_date).toLocaleDateString(),
        edit_date: new Date(customer.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchCustomers();
  },
  methods: {
    fetchCustomers() {
      axios
        .get('/api/v1/customer/customers/', { params: { show_inactive: true } })
        .then(response => {
          this.customers = response.data;
          this.totalCustomers = response.data.length;
          console.log('X', this.totalCustomers);
        })
        .catch(error => {
          console.error('Error fetching customers:', error);
        });
    },
    onAdd() {
      this.$router.push('/customers/add');
    },
    getEditUrl(row) {
      return `/customers/edit/${row.id}`;
    },
    toggleActive(row) {
      axios
        .patch(`/api/v1/customer/customers/${row.id}/`, { is_active: !row.is_active })
        .then(() => {
          this.$q.notify({
            color: 'green',
            message: `Customer ${row.is_active ? 'deactivated' : 'reactivated'}.`,
            icon: 'check'
          });
          this.fetchCustomers();
        })
        .catch(error => {
          console.error('Error updating customer active state:', error);
          this.$q.notify({
            color: 'red',
            message: 'Failed to update customer status.',
            icon: 'error'
          });
        });
    }
  },
  watch: {
    customers() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the CustomerTable here */
</style>
